import { ForwardedRef, forwardRef } from 'react';
import { Link } from 'react-router-dom';
import styles from './PatientLink.module.scss';
import { Icon, Text } from 'components';
import { useDevice } from 'hooks';
import { linkRegExp } from 'utils';

type Props = {
  link: string;
};

export const PatientLink = forwardRef(({ link }: Props, ref: ForwardedRef<HTMLAnchorElement>) => {
  const isLink = link?.match(linkRegExp);
  const { href } = window.location;
  const { isTablet } = useDevice();
  return (
    <Link
      to={link}
      key={link}
      state={!isLink ? { backPagePath: href } : {}}
      className={styles.link}
      target={isLink ? '_blank' : isTablet ? '_self' : '_blank'}
      rel="noreferrer"
      ref={ref}>
      <Icon name="Link" className={styles.linkIcon} />
      <Text type="body2" className={styles.linkText}>
        {link}
      </Text>
    </Link>
  );
});

PatientLink.displayName = 'PatientLink';
